import { LogoMark } from "./Logo";

const WORDS = ["Game", "Splatter", "Fluorescent", "Made in Western Australia", "Family owned", "For players & families everywhere"];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {WORDS.map((w, i) => (
      <span key={w} className="flex items-center">
        <span className={`px-8 font-display text-5xl font-extrabold uppercase tracking-tight sm:text-7xl ${i % 2 ? "font-serif-i normal-case font-normal text-[#6E472B]" : "text-[#112E23]"}`}>{w}</span>
        <LogoMark className="h-8 w-8 sm:h-10 sm:w-10" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="editorial-marquee" aria-label="POW highlights" className="overflow-hidden border-y border-[#112E23]/15 bg-[#F5F0E8] py-8">
    <div className="marquee-track flex w-max">
      <Row />
      <Row />
    </div>
  </section>
);
